import styled from 'styled-components';
import ds from 'designsystem';

const DebugOptionGroupLabel = styled.label`
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  padding-right: ${ds.get('metrics.xs')};
`;

export default DebugOptionGroupLabel;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionGroupLabel.jsx